import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const dashboardAPI = {
  getSummary: () => api.get('/dashboard/summary'),
  getCashFlow: (startDate, endDate) => api.get('/dashboard/cash-flow', { params: { start_date: startDate, end_date: endDate } }),
  getCategoryInsights: () => api.get('/dashboard/category-insights'),
  getMultiCurrency: (currencies) => api.get('/dashboard/multi-currency', { params: { currencies } }),
};

export const exchangeRateAPI = {
  getRates: (base) => api.get('/exchange-rates', { params: { base } }),
};

export const userAPI = {
  getAll: () => api.get('/users'),
  getById: (id) => api.get(`/users/${id}`),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
};

export const categoryAPI = {
  getAll: (type) => api.get('/categories', { params: { type } }),
  create: (data) => api.post('/categories', data),
  delete: (id) => api.delete(`/categories/${id}`),
  seed: () => api.post('/categories/seed'),
};

export const assetAPI = {
  getAll: () => api.get('/assets'),
  getById: (id) => api.get(`/assets/${id}`),
  create: (data) => api.post('/assets', data),
  update: (id, data) => api.put(`/assets/${id}`, data),
  delete: (id) => api.delete(`/assets/${id}`),
};

export const expenseAPI = {
  getAll: (params) => api.get('/expenses', { params }),
  getById: (id) => api.get(`/expenses/${id}`),
  create: (data) => api.post('/expenses', data),
  update: (id, data) => api.put(`/expenses/${id}`, data),
  delete: (id) => api.delete(`/expenses/${id}`),
};

export const incomeAPI = {
  getAll: (params) => api.get('/incomes', { params }),
  create: (data) => api.post('/incomes', data),
  delete: (id) => api.delete(`/incomes/${id}`),
};

export const loanAPI = {
  getAll: () => api.get('/loans'),
  getById: (id) => api.get(`/loans/${id}`),
  create: (data) => api.post('/loans', data),
  update: (id, data) => api.put(`/loans/${id}`, data),
  delete: (id) => api.delete(`/loans/${id}`),
  getSchedule: (id) => api.get(`/loans/${id}/schedule`),
};

export const creditCardAPI = {
  getAll: () => api.get('/credit-cards'),
  getById: (id) => api.get(`/credit-cards/${id}`),
  create: (data) => api.post('/credit-cards', data),
  update: (id, data) => api.put(`/credit-cards/${id}`, data),
  delete: (id) => api.delete(`/credit-cards/${id}`),
  getUtilization: (id) => api.get(`/credit-cards/${id}/utilization`),
};

export const budgetAPI = {
  getAll: () => api.get('/budgets'),
  getStatus: () => api.get('/budgets/status'),
  create: (data) => api.post('/budgets', data),
  delete: (id) => api.delete(`/budgets/${id}`),
};

export const goalAPI = {
  getAll: () => api.get('/goals'),
  getById: (id) => api.get(`/goals/${id}`),
  create: (data) => api.post('/goals', data),
  update: (id, data) => api.put(`/goals/${id}`, data),
  delete: (id) => api.delete(`/goals/${id}`),
};

export const predictionAPI = {
  calculate: (horizonDate, scenario) => api.post('/predictions/calculate', null, { params: { horizon_date: horizonDate, scenario } }),
};

export const aiAPI = {
  categorize: (description) => api.post('/ai/categorize', null, { params: { description } }),
  parseTransaction: (text) => api.post('/ai/parse-transaction', null, { params: { text } }),
  getInsights: () => api.post('/ai/insights'),
};
